import { Package, ExternalLink } from "lucide-react";
import { brl, fileUrl } from "@/lib/api";
import { EmptyState, Surface, Thumb } from "@/components/ds";
import { ProductStatusPill } from "./shared";

/** Consulta apenas: a criadora não cadastra, não edita e não altera preços. */
export const CreatorProducts = ({ data }) => {
  const products = data.products || [];

  if (products.length === 0)
    return (
      <EmptyState
        icon={Package}
        title="Você ainda não tem produtos vinculados"
        description="Assim que a TR3ND vincular um produto seu, ele aparece aqui."
        testid="creator-products-empty"
      />
    );

  const nonePublished = products.every((p) => !p.published);

  return (
    <div className="space-y-4" data-testid="creator-products">
      {nonePublished && (
        <Surface className="p-4 text-xs text-muted-foreground" data-testid="creator-products-preparing">
          Seus produtos estão em preparação: a TR3ND ainda está finalizando os detalhes
          comerciais (preço, estoque ou visibilidade) antes de publicá-los no catálogo.
        </Surface>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        {products.map((p) => (
          <Surface key={p.id} className="p-4" data-testid={`creator-product-${p.id}`}>
            <div className="flex items-start gap-3">
              <Thumb
                src={fileUrl(p.photo_path)}
                alt={p.name}
                className="h-14 w-14"
                fallback={<Package className="h-5 w-5 opacity-70" />}
              />
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-sm font-medium">{p.name}</p>
                {p.category && (
                  <p className="truncate text-[11px] text-muted-foreground">{p.category}</p>
                )}
                <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
                  <ProductStatusPill status={p.status} label={p.status_label}
                                     testid={`creator-product-status-${p.id}`} />
                  {p.price_missing && (
                    <span className="text-[10px] text-amber-300">Preço ainda não definido</span>
                  )}
                </div>
                <p className="mt-2 font-num text-base text-brand">{brl(p.price)}</p>
                {p.variations.length > 0 && (
                  <ul className="mt-2 space-y-0.5 text-[11px] text-muted-foreground">
                    {p.variations.map((v) => (
                      <li key={v.name}>
                        {v.name} · {v.available ? `${v.stock_units} un` : "esgotada"}
                      </li>
                    ))}
                  </ul>
                )}
                {p.catalog_path && (
                  <a
                    href={p.catalog_path}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-2 inline-flex items-center gap-1 text-[11px] text-brand"
                    data-testid={`creator-product-link-${p.id}`}
                  >
                    Ver no catálogo <ExternalLink className="h-3 w-3" />
                  </a>
                )}
              </div>
            </div>
          </Surface>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">
        Os produtos são fabricados e atendidos pela TR3ND. Para incluir um produto novo ou mudar
        preço, fale com a equipe.
      </p>
    </div>
  );
};
